module.exports = __webpack_public_path__ + "media/images/favicon-91bea460f2c00bff88d8bcbd5cfb6bf9.png";